/*
  The Instagram app injects its gallery into the footer rather than into this
  section, which leaves the posts detached from the heading that introduces
  them and the spacing between the two outside the section's control.

  Move the gallery into the section's posts container. If the app's block is
  added inside the section through the theme editor instead, it is already in
  the right place and nothing moves.
*/
(function () {
  var WIDGET = '.Vtl-InstagramFeedWidget';
  var ATTEMPTS = 20;
  var tries = 0;

  function place() {
    var posts = document.querySelector('.instagram-feed__posts');
    if (!posts) return true;

    var widget = document.querySelector(WIDGET);

    if (!widget) {
      // The gallery loads asynchronously; give it a few seconds.
      return ++tries > ATTEMPTS;
    }

    // Already inside the section: the Liquid order is correct.
    if (widget.closest('.instagram-feed')) return true;

    // The app wraps its gallery; move the wrapper so nothing it styles is
    // left behind in the footer.
    var wrapper = widget.parentElement || widget;
    posts.appendChild(wrapper);
    return true;
  }

  function start() {
    if (place()) return;
    var timer = setInterval(function () {
      if (place()) clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
